import EntityCrudPage from '../../shared/EntityCrudPage';
import { deploymentStatusConfig } from '../../config/entityConfigs';

const DeploymentStatusesPage = () => (
  <EntityCrudPage
    config={deploymentStatusConfig}
    subtitle="All registered deployment status rows from the Deployment Status table"
  />
);

export default DeploymentStatusesPage;
